/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

const Separator: FunctionComponent = () => {
    return <span className="uikit separator">|</span>;
};

export default Separator;
